import { Component, OnInit, inject, input } from '@angular/core';
import { HttpService } from '../../../services';

@Component({
  selector: 'app-report-image',
  templateUrl: './report-image.component.html',
  styleUrl: './report-image.component.scss',
})
export class ReportImageComponent implements OnInit {
  private readonly httpService = inject(HttpService);

  public readonly width = input(200);
  public readonly height = input(150);
  public readonly imageUrl = input<string>();

  public src = undefined;

  ngOnInit() {
    if (this.imageUrl()) {
      this.httpService.getAzureFile(this.imageUrl(), this.getFileType(this.imageUrl())).subscribe((blob) => {
        const reader = new FileReader();
        reader.onload = () => (this.src = reader.result as string);
        reader.readAsDataURL(blob);
      });
    }
  }

  getFileType(url: string): string {
    const parts = url.split('.');
    switch (parts[parts.length - 1].toLowerCase()) {
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
      default:
        return 'image/jpeg';
    }
  }
}
